import Vue from './common/vue-common';
import RenderNotifier from './components/common/RenderNotifier';
import Advantages from './components/common/Advantages.vue';
import ProductWholesalerSingleSize from './components/product/ProductWholesalerSingleSize.vue';
import ProductWholesalerMultipleSizes from './components/product/ProductWholesalerMultipleSizes.vue';
import ProductWholesalerSizesSummary from './components/product/ProductWholesalerSizesSummary.vue';
import SalesRepCartCustomerManager from './components/sales-rep/SalesRepCartCustomerManager.vue';
import Catalog from '../../../submodules/src/componentsV2/catalog/Catalog.vue';
import shop from '../../../submodules/src/script/i18n/shop';
import catalog from '../../../submodules/src/script/i18n/catalog';
import general from '../../../submodules/src/script/i18n/general';
import locale from '../../../submodules/src/script/i18n/locale';
import product from '../../../submodules/src/script/i18n/product';

new Vue({
    el: '#catalog-vue',
    i18n: locale(general(), catalog(), product(), shop()),
    components: {
        catalog: Catalog,
        'render-notifier': RenderNotifier,
        advantages: Advantages,
        'product-wholesaler-single-size': ProductWholesalerSingleSize,
        'product-wholesaler-multiple-sizes': ProductWholesalerMultipleSizes,
        'product-wholesaler-sizes-summary': ProductWholesalerSizesSummary,
        'sales-rep-cart-customer-manager': SalesRepCartCustomerManager,
    },
});
